@if (collapsed && (config.children && config.children.length > 0)) {
  <a
    mat-list-item
    [matTooltip]="config.label | translate"
    matTooltipPosition="right"
    routerLinkActive="active-link">
    <mat-icon [svgIcon]="config.svg ? config.icon: ''" matListItemIcon>{{ config.icon }}</mat-icon>
    @for (route of config.children; track route) {
      <a
        [ngStyle]="{ 'display': 'none' }"
      [routerLink]="route.routerLink"></a>
    }
  </a>
}

@if (collapsed && (!config.children || config.children.length === 0)) {
  <a
    mat-list-item
    [routerLink]="config.routerLink"
    [matTooltip]="config.label | translate"
    matTooltipPosition="right"
    routerLinkActive="active-link">
    <mat-icon [svgIcon]="config.svg ? config.icon: ''" matListItemIcon>{{ config.icon }}</mat-icon>
  </a>
}

@if (!collapsed && (!config.children || config.children.length === 0)) {
  <a
    class="expanded-nav-item"
    mat-list-item
    [routerLink]="config.routerLink"
    routerLinkActive="active-link"
    [routerLinkActiveOptions]="{ 'exact': true }">
    <mat-icon [svgIcon]="config.svg ? config.icon: ''" matListItemIcon>{{ config.icon }}</mat-icon>
    <span [translate]="config.label">Config label</span>
  </a>
}